import Icon, { IconName } from "components/atoms/Icon";
import React, { memo } from "react";
import { joinClassnames, mapMultiClassnames } from "utils/map-modifier";

interface ListItemProps {
  iconName: IconName;
  children: React.ReactNode;
  modifiers?: ("warning")[];
  className?: string;
}

const ListItem: React.FC<ListItemProps> = ({
  iconName,
  children,
  modifiers,
  className,
}: ListItemProps) => (
  <li
    className={joinClassnames(
      mapMultiClassnames("m-list-item", modifiers),
      className,
    )}
  >
    {iconName && (
      <i className="m-list-item_icon">
        <Icon iconName={iconName} />
      </i>
    )}

    <label>{children}</label>
  </li>
);

export default memo(ListItem);
